<div *ngIf="notSignedIn$ | async"
     class="flex align-items-center justify-content-center w-screen h-screen">
  <button pButton
          class="p-button-outlined text-white"
          label="Sign In"
          (click)="login()"></button>
</div>